import ErrorOutlineIcon from "@mui/icons-material/ErrorOutlineRounded";
import { Stack, Tooltip } from "@mui/material";
import type { ConditionField } from "../../../../../../../../api/types/svTypes.ts";
import { ItemDataType } from "../../../../../../../../api/types/svTypes.ts";
import LinkIcon from "@entrilia/shared/icons/LinkIcon.tsx";
import AreaFieldItem from "../fields/area-fields/AreaFieldItem.tsx";
import type { FieldItemProps } from "../fields/area-fields/areaFiledItem.types.ts";
import ConditionMarker from "./ConditionMarker.tsx";

interface Props extends FieldItemProps<ConditionField> {
  marked?: boolean;
  linked?: boolean;
}

const ConditionItem = ({
  marked,
  linked,
  field,
  canBeRemoved,
  readonly,
  onRemoveItem,
  formatCaption,
  onShowOptions,
  optionRef,
  autoShowItemOptionsId,
  onSetAutoShowItemOptionsId,
}: Props) => {
  const shouldOptionsBeHidden =
    readonly && (field.meta.type === ItemDataType.Date || field.meta.type === ItemDataType.Numeric);

  const isInactive = field.validation?.invalid;
  const hasMissingMandatoryValue = field.config.mandatory === true && (field.config.filter?.values.length ?? 0) === 0;

  return (
    <>
      {marked && <ConditionMarker />}
      <Stack
        direction="row"
        sx={(t) => ({
          flex: 1,
          display: "flex",
          width: "100%",
          alignItems: "center",
          backgroundColor: readonly ? t.palette.action.disabledBackground : "none",
        })}
      >
        {linked && <LinkIcon sx={{ pl: 1 }} />}
        {isInactive && (
          <Tooltip title={field.validation?.message}>
            <ErrorOutlineIcon color="secondary" sx={{ ml: 1 }} />
          </Tooltip>
        )}
        {!isInactive && hasMissingMandatoryValue && (
          <Tooltip title="This condition is mandatory. Set a value before running the report.">
            <ErrorOutlineIcon color="error" sx={{ ml: 1 }} />
          </Tooltip>
        )}
        <AreaFieldItem
          field={field}
          canBeRemoved={canBeRemoved}
          removeButtonLabel="Remove condition"
          readonly={readonly}
          hideOptions={shouldOptionsBeHidden}
          onRemoveItem={onRemoveItem}
          formatCaption={formatCaption}
          onShowOptions={onShowOptions}
          optionRef={optionRef}
          autoShowItemOptionsId={autoShowItemOptionsId}
          onSetAutoShowItemOptionsId={onSetAutoShowItemOptionsId}
        />
      </Stack>
    </>
  );
};

export default ConditionItem;
